// eslint-disable-next-line no-restricted-imports
import { useEffect, useLayoutEffect } from 'react'

export const useIsomorphicLayoutEffect = global.document ? useLayoutEffect : useEffect
